import { useProjectsTimeZone } from 'modules/experiments/hooks';
import { getFormattedDateWithHoursAndMins } from 'modules/experiments/utils';

import { BaseCellWrapper, CustomDateDisplayWrapper } from './Styled';

type DateCellProps = {
  date?: string;
  customDisplay?: string;
};

export const DateCell = ({ date, customDisplay = '' }: DateCellProps) => {
  const timezone = useProjectsTimeZone();
  if (customDisplay) return <CustomDateDisplayWrapper>{customDisplay}</CustomDateDisplayWrapper>;
  if (!date) return <BaseCellWrapper>{''}</BaseCellWrapper>;
  return <BaseCellWrapper>{getFormattedDateWithHoursAndMins(date, timezone)}</BaseCellWrapper>;
};
